import { NotKutusu } from "@koclukpanel/ui";
import type { YedekKodBandi as Bant } from "./yedek-kod-uyarisi";

/**
 * YEDEK KOD BANDI — G-AUT-02a
 *
 * ================================================================
 * NEDEN AYRI BİR BİLEŞEN: İKİ YÜZEY, TEK METİN
 * ================================================================
 * Bu bant 05.09.2026'ya kadar `Uygulama.tsx` içinde, öğrenci
 * kabuğunun çocuklarında **satır içi** duruyordu. Veli aynı
 * uygulamaya taşınınca ikinci bir yüzey açıldı ve bant o yüzeye
 * hiç ulaşmadı — ölçüldü: `VeliKabugu` `bant`ı hiç almıyordu.
 *
 * Bandı ikinci kez elle yazmak, bu projede gün boyu raporlanan
 * sınıfın aynısını üretirdi: *aynı ekranın iki kopyası, biri
 * düzeltilince öteki geride kalır*. O yüzden metin ve düğme burada
 * TEK yerde; iki kabuk da bunu çağırıyor.
 *
 * Karar `yedek-kod-uyarisi.ts` içinde ve saf: bu dosya yalnızca
 * çiziyor. `bant` `null` ise hiçbir şey çizilmiyor — "yedek kod
 * harcanmadı" hâlinde boş bir kutu göstermek, olmayan bir olayı
 * duyurmak olurdu.
 */
export function YedekKodBandi({ bant, onKapat }: { bant: Bant | null; onKapat: () => void }) {
  if (!bant) return null;

  return (
    <div className="px-4 pt-4">
      <NotKutusu ton={bant.ton} duyur className="items-center">
        <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <span>{bant.metin}</span>
          <button
            type="button"
            onClick={onKapat}
            className="min-h-dokunma underline underline-offset-2"
          >
            Anladım
          </button>
        </span>
      </NotKutusu>
    </div>
  );
}
